import { useSmsStore } from "@/stores/sms/index";
import { useRouter } from "#app";

export default defineNuxtRouteMiddleware((to, from) => {
  const smsStore = useSmsStore();
  const router = useRouter();

  if (!smsStore.editDataForm) {
    router.push("/send/report-receive-send");
  }
});
